import styled from 'styled-components'

export const SubmissionCaption = styled.div`
  white-space: pre-wrap;
  word-wrap: break-word;
`
